import React, { useState, useEffect } from 'react';
import { RestHelperNoAuth } from "../helper/restHelperNoAuth";
import { Link } from 'react-router-dom'
import mixpanel from "mixpanel-browser";
import './title-hero.css';

const TitleHero = () => {
  // SEO: Set page title and meta description
  useEffect(() => {
    document.title = "Mobile Notary Services for Title Companies | Pinpoint Field Services";

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content',
        'Professional mobile notary services for title companies and escrow officers. Nationwide coverage, 24-hour turnaround, verified signing agents. Call (888) 530-7592.'
      );
    }

    // Add structured data for reviews and FAQ
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.id = 'title-hero-schema';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "ProfessionalService",
          "@id": "https://www.pinpointfieldservices.com/#organization",
          "name": "Pinpoint Field Services",
          "description": "Professional mobile notary services for title companies and escrow officers nationwide.",
          "telephone": "+1-888-530-7592",
          "url": "https://www.pinpointfieldservices.com",
          "areaServed": "United States",
          "serviceType": ["Mobile Notary", "Signing Agent Services", "Loan Closing Services"],
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "5",
            "bestRating": "5",
            "ratingCount": "50",
            "reviewCount": "50"
          }
        },
        {
          "@type": "Review",
          "itemReviewed": { "@id": "https://www.pinpointfieldservices.com/#organization" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "author": { "@type": "Person", "name": "Settlement Agent" },
          "reviewBody": "As a settlement agent who works with several different mobile notary companies, I have to say Pinpoint is TOP NOTCH! Michael and his team are quick, reliable and I never have to worry about a lack of experience."
        },
        {
          "@type": "Review",
          "itemReviewed": { "@id": "https://www.pinpointfieldservices.com/#organization" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "author": { "@type": "Person", "name": "Barbara B." },
          "reviewBody": "Fantastic service to work with! Great communication and integrity!"
        },
        {
          "@type": "Review",
          "itemReviewed": { "@id": "https://www.pinpointfieldservices.com/#organization" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "author": { "@type": "Person", "name": "Janet S." },
          "reviewBody": "Love this company, they are very conscientious and do what they say they will do. I would work with them any day."
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What areas do you cover for mobile notary services?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Pinpoint Field Services provides mobile notary coverage across all 50 states with a network of over 8,000 verified signing agents."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you schedule a signing agent?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We offer 24-hour turnaround for most requests. For rush signings, we can often connect you with a qualified notary within hours."
              }
            },
            {
              "@type": "Question",
              "name": "What types of documents can your notaries handle?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Our signing agents specialize in real estate transactions including loan closings, refinances, seller deed sets, and Remote Online Notary (RON) services."
              }
            },
            {
              "@type": "Question",
              "name": "How do I track the status of my signing?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Our secure portal provides real-time updates at every stage of the signing process, from scheduling to document return. You can also communicate directly through our message center."
              }
            }
          ]
        }
      ]
    });
    document.head.appendChild(schemaScript);

    // Cleanup: restore defaults on unmount
    return () => {
      document.title = "Pinpoint Field Services";
      if (metaDescription) {
        metaDescription.setAttribute('content',
          'Home page for Pinpoint Field Services - Providing peace of mind for closings and inspections.'
        );
      }
      const existingSchema = document.getElementById('title-hero-schema');
      if (existingSchema) {
        existingSchema.remove();
      }
    };
  }, []);
      const [showForm1, setShowForm1] = useState(false);
      const [showForm2, setShowForm2] = useState(false);
      const [formTitle, setFormTitle] = useState('Ready To Streamline Your Processes')
      const [formComments, setFormComments] = useState('Company Name')
      const [formCommentsDescription, setFormCommentsDescription] = useState('Name of Title Company')
      const [apiRes, setApiRes] = useState('')
      const [showResponse, setShowResponse] = useState(false)
      const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        comments: '',
        subject: ''
      });



    const handleResponse = (e) => {
        setApiRes(e)
        setShowResponse(true)
        setFormData({
            ...formData,
            ['name']: '',
            ['email']: '',
            ['phone']: '',
            ['comments']: '',
            ['subject']: ''
        })
      }
      const handleShowForm = (param, param2) => {
        if (param === 'notary'){
          setFormTitle('Notary Request Form')
          setFormComments('Notarization Needs')
          setFormCommentsDescription('Please describe what you need notarized')
          mixpanel.track('Title Landing Page', {'action' : 'Show Notary Contact Us Form'})
        }
        else {
          setFormTitle('Ready To Streamline Your Processes?')
          setFormComments('Company Name')
          setFormCommentsDescription('Name of Title Company')
          mixpanel.track('Title Landing Page', {'action' : 'Show Title Company Contact Us Form'})
        }
    
        if (param2 === '1'){
            setShowForm1(true);
        }
        else{
            setShowForm2(true)
        }
        
      }
      //const handleCloseForm = () => setShowForm(false);
      const [error, setError] = useState('');
      const api = RestHelperNoAuth()
    
        // Handle form input changes
        const handleChange = (e) => {
            setFormData({
              ...formData,
              [e.target.name]: e.target.value,
            });
          };
    
      // Function to handle form submission
      const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent page reload on form submission
    
        // Simple validation example (you can add more specific checks if needed)
        if (!formData.name || !formData.email || !formData.phone || ! formData.comments) {
          setError('Please fill in all required fields');
          return;
        }
        mixpanel.track('Title Landing Page', {'action' : 'SubmitRequest'})
        try {
          // Send data to your API using fetch
          callApi()
           // Trigger Google Ads conversion event
          window.gtag('event', 'conversion', {
          'send_to': 'AW-1023542218/irtdCKSJ0YMaEMqHiOgD',
          'value': 1.0,
          'currency': 'USD',
        });
        } catch (error) {
          // Handle network errors
          setError('There was an error submitting your request. Please try again later.');
        }
      };
    
      const callApi = () => {
        const options = {}
        setShowForm1(false)
        setShowForm2(false)
        api
        .postCreate('/create-contact-request', options, formData)
        .then(res => handleResponse(res))
        .catch(err => console.log(err))
    }
  
    return (
      <main className="landing-page" role="main">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1>Mobile Notary Services for Title Companies & Escrow Officers</h1>
              <p>Trusted by leading title companies and escrow officers nationwide. We handle the notary logistics so you can focus on your closings.</p>
              
              <div className="d-flex flex-wrap justify-content-center mt-4 mb-4">
                <span className="benefit-tag">Nationwide Coverage</span>
                <span className="benefit-tag">24-Hour Turnaround</span>
                <span className="benefit-tag">Dedicated Account Manager</span>
                <span className="benefit-tag">Verified Professionals</span>
                <span className="benefit-tag">Competitive Pricing</span>
              </div>
              
              <button className="cta-button" onClick={(e) => {handleShowForm('notary', '1')}}>Schedule Your Notary Today</button>
              <p className="mt-3" style={{ color: '#d4d4d4' }}>
                <Link to="/about-us" style={{ color: '#00bfff' }}>Learn more about our company</Link> | <Link to="/support" style={{ color: '#00bfff' }}>Contact support</Link>
              </p>
            </div>
          </div>
        </section>

              {/* Form section (shows when CTA is clicked) */}

        {showResponse &&
        <div className="info-section">
            <p>{apiRes}</p>
        </div>
      }
      {showForm1 && (
        <div className="form-container">
          <div className="form-header">
            <h2>{formTitle}</h2>
            {/* X button to close the form */}
            <button className="close-button" onClick={() => setShowForm1(false)}>X</button>
          </div>
          <form className="appraisal-form" onSubmit={handleSubmit}>
            <h6>Thanks for your interest, please fill out the below form or give us a call at <a href="tel:888-530-7592" className='phone-link'>888-530-7592</a>.  We'll be in touch soon!</h6>
            <br/>
            <label>Name:</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required />
            
            <label>Email Address:</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" required />
            
            <label>Callback Number:</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Your Phone Number" required />
            
            <label>{formComments}:</label>
            <textarea name="comments" value={formData.comments} onChange={handleChange} placeholder={formCommentsDescription} />
            
            <label>City, State:</label>
            <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="City, State" />
            
            {/* Display error message if validation fails */}
            {error && <p className="error-message">{error}</p>}
            
            <button type="submit" className="submit-button">Submit</button>
          </form>
        </div>
      )}
  
        {/* Stats Section */}
        <section className="stats-section">
          <div className="container">
            <div className="row text-center">
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>★★★★★</h3>
                <p>Google Reviews Rating</p>
              </div>
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>20+</h3>
                <p>Years of Industry Experience</p>
              </div>
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>50</h3>
                <p>States Covered</p>
              </div>
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>8,000+</h3>
                <p>Verified Notaries</p>
              </div>
              
            </div>
          </div>

        </section>
  
        {/* Features Section */}
        <section className="features-section">
          <div className="container">
      <div className="text-center mb-4">
          <img
                  src="/img/pinpoint-closing-secondary.jpg"
                  alt="Mobile notary signing agent completing real estate closing documents with homebuyers"
                  className="img-fluid"
                  loading="lazy"
                  width="600"
                  height="400"
                  style={{
                    maxWidth: '600px',
                    width: '100%',
                    borderRadius: '8px',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)'
                  }}
              />
            </div>
            <div className="text-center mb-5">
              <h2>Specialized Notary Services for Title & Escrow</h2>
              <p className="mb-5">We understand the unique needs of title companies and escrow offices when it comes to document signings.</p>
            </div>
            
            <div className="row">
              {/* Feature 1 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <div className="feature-icon">📝</div>
                  <h3>Loan Closings</h3>
                  <p>Our notaries are experienced with mortgage loan documents and follow your specific instructions to ensure a smooth closing experience for all parties.</p>
                </div>
              </div>
              
              {/* Feature 2 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <div className="feature-icon">⏱️</div>
                  <h3>Rush Signings</h3>
                  <p>Need a notary on short notice? Our expedited service can connect you with a qualified professional within hours, not days.</p>
                </div>
              </div>
              
              {/* Feature 3 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <div className="feature-icon">🏠</div>
                  <h3>Remote Locations</h3>
                  <p>We specialize in reaching signers in rural and hard-to-serve areas where many services don't have coverage.</p>
                </div>
              </div>
              
              {/* Feature 4 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <div className="feature-icon">📲</div>
                  <h3>Real-Time Updates</h3>
                  <p>Stay informed with automated notifications at every stage of the signing process from scheduling to document return.</p>
                </div>
              </div>
              
              {/* Feature 5 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                <div className="feature-icon">✉️</div>
                  <h3>Message Center</h3>
                  <p>Secure messaging portal to track all communications for your order, including secured access for your escrow team to cover orders across the team.</p>
                </div>
              </div>
              
              {/* Feature 6 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <div className="feature-icon">🔄</div>
                  <h3>Document Tracking</h3>
                  <p>Our secure system tracks all documents from printing to return shipping, ensuring nothing gets lost in the process.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
  
  
        {/* Process Section */}
        <section className="process-section">
          <div className="container">
            <div className="text-center mb-5">
              <h2>A Seamless Process Designed for Title Companies</h2>
              <p className="mb-4">We've streamlined every step to make working with us effortless.</p>
            </div>
            
            <div className="mx-auto" style={{ maxWidth: '800px' }}>
              {/* Step 1 */}
              <div className="process-step">
                <div className="step-number">1</div>
                <div>
                  <h4>Submit Your Request</h4>
                  <p>Use our online portal, email, or call your dedicated account manager with the signing details. We'll confirm receipt within minutes.</p>
                </div>
              </div>
              
              {/* Step 2 */}
              <div className="process-step">
                <div className="step-number">2</div>
                <div>
                  <h4>We Handle Scheduling</h4>
                  <p>Our team contacts the signers, arranges a convenient time, and confirms the appointment with all parties.</p>
                </div>
              </div>
              
              {/* Step 3 */}
              <div className="process-step">
                <div className="step-number">3</div>
                <div>
                  <h4>Professional Signing Agent Assigned</h4>
                  <p>We match your signing with a vetted, experienced notary who specializes in real estate transactions.</p>
                </div>
              </div>
              
              {/* Step 4 */}
              <div className="process-step">
                <div className="step-number">4</div>
                <div>
                  <h4>Signing Completed</h4>
                  <p>The notary executes the signing according to your instructions and provides immediate confirmation upon completion.</p>
                </div>
              </div>
              
              {/* Step 5 */}
              <div className="process-step">
                <div className="step-number">5</div>
                <div>
                  <h4>Secure Document Return</h4>
                  <p>Documents are returned via your preferred method—overnight shipping, secure upload, or courier service.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Signing Agent CTA */}
        <section className="info-section" style={{ backgroundColor: '#e8f4fc' }}>
          <div className="container text-center">
            <h3>Are You a Signing Agent?</h3>
            <p>Join our nationwide network of verified notary signing agents. We're always looking for experienced professionals.</p>
            <Link to="/sign-up" className="cta-button" style={{ display: 'inline-block', textDecoration: 'none' }}>Apply to Join Our Network</Link>
          </div>
        </section>

        {/* Testimonials */}
        <section className="testimonials-section">
          <div className="container">
            <div className="text-center mb-5">
              <h2>Trusted by Title Companies Nationwide</h2>
              <p>Don't just take our word for it. Here's what our clients have to say.</p>
            </div>
            
            <div className="row">
              {/* Testimonial 1 */}
              <div className="col-lg-6 col-md-6">
                <article className="testimonial-card" itemScope itemType="https://schema.org/Review">
                  <blockquote className="testimonial-content" itemProp="reviewBody">"As a settlement agent who works with several different mobile notary companies, I have to say Pinpoint is TOP NOTCH! Michael and his team are quick, reliable and I never have to worry about a lack of experience. The process and systems for Pinpoint are so user friendly and makes my job that much easier!"</blockquote>
                  <footer className="testimonial-author">
                    <div className="author-avatar" aria-hidden="true"></div>
                    <div>
                      <cite><strong itemProp="author">Settlement Agent in Nebraska</strong></cite>
                    </div>
                  </footer>
                </article>
              </div>

              {/* Testimonial 2 */}
              <div className="col-lg-6 col-md-6">
                <article className="testimonial-card" itemScope itemType="https://schema.org/Review">
                  <blockquote className="testimonial-content" itemProp="reviewBody">"Pinpoint Field Services offers not only professional and prompt service as a course of regular business, but has also stepped in and gone above and beyond to get things done when needed. This level of support helps everyone involved achieve a common goal and they understand how valuable that is. I trust them wholly to be that valued partner that helps me do my job better."</blockquote>
                  <footer className="testimonial-author">
                    <div className="author-avatar" aria-hidden="true"></div>
                    <div>
                      <cite><strong itemProp="author">Title Company in Nebraska</strong></cite>
                    </div>
                  </footer>
                </article>
              </div>

            </div>
          </div>
        </section>

        
      {/* Google Reviews Section */}
      <section className="reviews-section">
        <h2>Google Reviews</h2>
        <div className="google-reviews col">
          {/* Placeholder for embedding Google Reviews */}
          <p>★★★★★</p>
          <p>"Fantastic service to work with! Great communication and integrity!" - Barbara B.</p>
        </div>
        <hr/>
        <div className="google-reviews col">
          {/* Placeholder for embedding Google Reviews */}
          <p>★★★★★</p>
          <p>"Love this company, they are very conscientious and do what they say they will do. I would work with them any day." - Janet S.</p>
        </div>
        <hr/>
        <div className="google-reviews col">
          {/* Placeholder for embedding Google Reviews */}
          <p>★★★★★</p>
          <p>"Thank you for the opportunity to work with you and your company. The experience was exceptional, and the professionalism was top-notch throughout the process. Highly recommend!" - Krishanna F.</p>
        </div>
        <button className="cta-button" onClick={handleShowForm}>Learn More</button>
      </section>

        {/* FAQ Section */}
        <section className="faq-section" aria-labelledby="faq-heading">
          <div className="container">
            <div className="text-center mb-5">
              <h2 id="faq-heading">Frequently Asked Questions</h2>
              <p>Common questions from title companies and escrow officers</p>
            </div>

            <div className="faq-container">
              <div className="faq-item">
                <h3>What areas do you cover for mobile notary services?</h3>
                <p>Pinpoint Field Services provides mobile notary coverage across all 50 states with a network of over 8,000 verified signing agents.</p>
              </div>

              <div className="faq-item">
                <h3>How quickly can you schedule a signing agent?</h3>
                <p>We offer 24-hour turnaround for most requests. For rush signings, we can often connect you with a qualified notary within hours.</p>
              </div>

              <div className="faq-item">
                <h3>What types of documents can your notaries handle?</h3>
                <p>Our signing agents specialize in real estate transactions including loan closings, refinances, seller deed sets, and Remote Online Notary (RON) services.</p>
              </div>

              <div className="faq-item">
                <h3>How do I track the status of my signing?</h3>
                <p>Our secure portal provides real-time updates at every stage of the signing process, from scheduling to document return. You can also communicate directly through our message center.</p>
              </div>
            </div>

            <div className="text-center mt-4">
              <p>Have more questions? <Link to="/support" style={{ color: '#00bfff', fontWeight: 'bold' }}>Contact our support team</Link></p>
            </div>
          </div>
        </section>

        {/* CTA Section / Contact */}
        <section id="contact" className="hero-section">
          <div className="container">
            <h2>Ready to Simplify Your Closing Process?</h2>
            <p className="mb-4">Schedule a consultation with our team to discuss your notary service needs and learn how we can support your title company's success.</p>
            <button className="cta-button" onClick={(e) => {handleShowForm('default', '2')}}>Schedule a Consultation</button>
            <p className="mt-3">Or call us directly: <a href="tel:8885307592" className="phone-link">(888) 530-7592</a></p>
            <p className="mt-4" style={{ color: '#d4d4d4', fontSize: '0.9rem' }}>
              <Link to="/about-us" style={{ color: '#00bfff' }}>About Us</Link> | <Link to="/support" style={{ color: '#00bfff' }}>Support</Link> | <Link to="/sign-up" style={{ color: '#00bfff' }}>Become a Signing Agent</Link>
            </p>
          </div>
        </section>
  
        {/* Form Popup */}

        {showResponse &&
        <div className="info-section">
            <p>{apiRes}</p>
        </div>
      }

        {showForm2 && (
        <div className="form-container">
          <div className="form-header">
            <h2>{formTitle}</h2>
            {/* X button to close the form */}
            <button className="close-button" onClick={() => setShowForm2(false)}>X</button>
          </div>
          <form className="appraisal-form" onSubmit={handleSubmit}>
            <h6>Thanks for your interest, please fill out the below form or give us a call at <a href="tel:888-530-7592" className='phone-link'>888-530-7592</a>.  We'll be in touch soon!</h6>
            <br/>
            <label>Name:</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required />
            
            <label>Email Address:</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" required />
            
            <label>Callback Number:</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Your Phone Number" required />
            
            <label>{formComments}:</label>
            <textarea name="comments" value={formData.comments} onChange={handleChange} placeholder={formCommentsDescription} />
            
            <label>City, State:</label>
            <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="City, State" />
            
            {/* Display error message if validation fails */}
            {error && <p className="error-message">{error}</p>}
            
            <button type="submit" className="submit-button">Submit</button>
          </form>
        </div>
      )}

      </main>
    );
  };

export default TitleHero;